module.exports = __webpack_public_path__ + "media/images/talent/fukidashi-01-b7fa76c6aea404b3873ca2448950dbb2.png";